export default {
  Aa: "invalid_api_key",
  Ba: "blacklisted",
  Na: "no_device_identifier",
  qa: "invalid_json_response",
  Ra: "empty_response",
  __: "sdk_auth_error",
};
